/*
  cs-g5b-picks.js（V12 丙組，只 g5b 首頁用；由 snippets/cs-g5b-picks.liquid 的那一列載入）

  兩件事：
  1. pickZone：選件規則，一個純函式（沒有 DOM、沒有網路）。頁面用它，本機對照用 node 直接 require 同一個檔跑
     （.v8-work/v12c/run-page-fn.js），所以「頁面那段」和「對照腳本」比的是同一份程式。
  2. boot：頁面膠水。讀每個專區精選列裡的候選 JSON，取 /collections/all?sort_by=best-selling 的名次，
     依規則重排；失敗就保留伺服器端那一列並印 data-cs-miss="pick-sort"。不重試（429 也一次就停）。

  規則（每專區，件數 n 由列的 data 帶進來，現行 6／5／6）：
    1. anchor：主類別裡，名次最前、有貨的 anchorN（2）件。主類別由伺服器端（snippets/cs-g5b-pool-ctx）依規則決定並用 a 標在候選上：
       第一個「不和別區共用、專屬商品夠多」的系列；沒有就用該區總系列（整區候選都算）。
    2. new：60 天內上架的候選，新到舊；和其他階段同一條品牌上限（每品牌 <perVendor）；有合格新品（沒違反品牌與類型上限）就至少放 1 件。
       V14 R2：兩件新品彼此不同品牌（第 2 件新品的品牌不可等於第 1 件新品的；沒有就只放 1 件）；新品可以和已選的非新品同品牌。
    3. best：其餘照名次補滿；補位階段不再選 60 天內上架的商品。
    全程：每品牌最多 perVendor（2）件、每個商品類型最多 perType（3）件（anchor、new 也算進去）。
    整列 60 天內上架的商品最多 newN（2）件（V13 r3 裁定：newN 管「整列」，anchor 裡的新品也算；補位不再選新品）。
    名次缺的（還沒抓到那一頁、或名單裡沒有）排在有名次的後面，彼此照伺服器端順序。
    V14 R3 補不滿時放寬（順序固定、全自動）：第一輪照全部規則；仍少格 → 放寬「同種類最多 perType 件」再補；仍少格 → 再放寬「整列新品最多 newN 件」再補。
    永不放寬：品牌上限、杯具與 Sharing Cup 排除（候選池就濾掉）、售完不出（候選池只有有貨）。仍不滿就少格，回傳 short＞0（頁面印 data-cs-miss="pick-short"）。
    放寬記號 relax 由最後的結果算（不是由「進過哪一關」算）：有任一種類超過 perType 件 → 含 kind；整列新品超過 newN 件 → 含 new；兩者皆有寫成 "kind new"，都沒有是空字串。
    放寬補上的商品接在原有選件後面（不重排原有的）。
  候選池（pool）在伺服器端就先濾過：只放有貨、不在 section 排除清單、不在「精選排除系列」（含咖啡杯系列）、handle 不含 coffee-stage-sharing-cup、不是同區種類格拿去當圖的那件。
  頁面端另外把「頁面上別處已出現的商品」（blocked）排掉，和既有的去重規則一致；「更多好物」那一格不算，精選優先，之後從那邊移除重複。
  V14 r3：
    全頁同一件商品只出現一次（店主原型 E 第 2、11 點）：「已出現」＝main 裡「看得見」的商品連結（新品區、各專區分列、其他精選列都算；精選列自己、「更多好物」、Sharing Cup 區塊不算）。
      看得見＝商品卡（最近的 li，沒有就連結本身）getClientRects().length > 0；節點沒插進文件、或在 display:none 的祖先底下都回 0 → 不算看見。沒有 getClientRects 的環境（node 假 DOM）一律當看得見。
    #1／#3：換下的卡不再「當下接不回就丟」。一律排進待接回清單，由同步器（reconcile）依「看得見」決定放不放進「更多好物」開頭；
      同步器掛在「更多好物」grid 的 MutationObserver（子節點變動就同步：feed 首批載入、換清單、看更多都會觸發）與 matchMedia('(min-width: 750px)') 的 change（跨 750 可見性會變），
      feed 元素 finished 之後取消 MutationObserver；沒有 grid（頁面上沒有「更多好物」）就在列上印 data-cs-miss="rescue-nofeed"。
    #7：品牌上限用 trim＋toLowerCase 後的字串比對（顯示與輸出仍用原字串）；#5：計數表一律 Object.create(null)。
*/
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) { module.exports = api; }
  if (root && root.document) { root.CSG5bPicks = api; api.guardSlideStop(root); api.patchSnapSize(root); api.boot(root); }
})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : this), function () {
  'use strict';

  var HAS = Object.prototype.hasOwnProperty;

  // #7：品牌比對用 trim＋小寫後的字串（Liquid 那邊是 strip＋downcase）；顯示與輸出用原字串
  function normV(v) { return String(v == null ? '' : v).trim().toLowerCase(); }

  function cmpRank(a, b) {
    if (a.r === b.r) { return a.i - b.i; }
    return a.r < b.r ? -1 : 1;
  }

  /**
   * @param {Array} pool  [{h, v, t, p, a}] 伺服器端順序；h handle、v 品牌、t 商品類型、p 上架時間（秒）、a 是否在主類別系列
   * @param {Object} rank handle -> 名次（1 起算，越小越熱銷）；沒有的視為未知
   * @param {Object} o    {n, anchorN, newN, newDays, perVendor, perType, now(秒), blocked:{handle:1}, exhausted:boolean}
   * @returns {{picks:Array, candidates:number, final:boolean}}
   */
  function pickZone(pool, rank, o) {
    var n = o.n;
    var anchorN = o.anchorN;
    var newN = o.newN;
    var perV = o.perVendor;
    var perT = o.perType;
    var newFrom = o.now - o.newDays * 86400;
    var blocked = o.blocked || {};
    var seenH = Object.create(null);
    var cand = [];
    var i;
    for (i = 0; i < pool.length; i += 1) {
      var c = pool[i];
      if (HAS.call(blocked, c.h) || HAS.call(seenH, c.h)) { continue; }
      seenH[c.h] = 1;
      cand.push({ h: c.h, v: c.v, nv: normV(c.v), t: c.t, p: c.p, a: c.a ? 1 : 0, i: i, r: (rank && HAS.call(rank, c.h)) ? rank[c.h] : Infinity });
    }
    var byRank = cand.slice().sort(cmpRank);
    var picks = [];
    var vc = Object.create(null);
    var tc = Object.create(null);
    var got = Object.create(null);
    var freshV = Object.create(null); // R2：已選新品的品牌（正規化後的字串）
    var nAnchor = 0;
    var nFresh = 0; // 整列 60 天內上架的件數（anchor、new、best 全算）
    function isFresh(x) { return x.p >= newFrom; }
    // lv：0＝全部規則；1＝放寬同種類上限；2＝再放寬整列新品上限。品牌上限、不重複永不放寬；新品彼此不同品牌（R2）不屬於放寬的兩項，不放寬
    function ok(x, lv) {
      if (HAS.call(got, x.h) || (vc[x.nv] || 0) >= perV) { return false; }
      if (lv < 1 && (tc[x.t] || 0) >= perT) { return false; }
      return !(isFresh(x) && HAS.call(freshV, x.nv));
    }
    function take(x, rule) {
      got[x.h] = 1;
      if (isFresh(x)) { nFresh += 1; freshV[x.nv] = 1; }
      vc[x.nv] = (vc[x.nv] || 0) + 1;
      tc[x.t] = (tc[x.t] || 0) + 1;
      picks.push({ h: x.h, rule: rule, rank: isFinite(x.r) ? x.r : null, i: x.i, v: x.v, t: x.t, p: x.p });
    }
    var fresh = cand.filter(isFresh);
    fresh.sort(function (a, b) { return a.p === b.p ? cmpRank(a, b) : b.p - a.p; });
    function stages(lv) {
      var k;
      // 1. anchor
      for (k = 0; k < byRank.length && picks.length < n && nAnchor < anchorN; k += 1) {
        if (byRank[k].a && ok(byRank[k], lv)) { take(byRank[k], 'anchor'); nAnchor += 1; }
      }
      // 2. new：新到舊（同一時間再看名次、伺服器順序）。品牌與類型上限和其他階段同一條；整列新品（含 anchor 裡的）到上限就停
      for (k = 0; k < fresh.length && picks.length < n && (lv >= 2 || nFresh < newN); k += 1) {
        if (ok(fresh[k], lv)) { take(fresh[k], 'new'); }
      }
      // 3. best：補位不再選新品（lv>=2 才可以，因為整列新品上限已放寬）
      for (k = 0; k < byRank.length && picks.length < n; k += 1) {
        if (ok(byRank[k], lv) && (lv >= 2 || !isFresh(byRank[k]))) { take(byRank[k], 'best'); }
      }
    }
    stages(0);
    if (picks.length < n) { stages(1); }
    if (picks.length < n) { stages(2); }
    var relaxKind = Object.keys(tc).some(function (t) { return tc[t] > perT; });
    var relax = (relaxKind ? 'kind' : '') + (relaxKind && nFresh > newN ? ' ' : '') + (nFresh > newN ? 'new' : '');
    // 名次還沒抓完時，結果算不算定案：每一件 anchor／best 都有名次、格子滿了、anchor 夠數（或主類別系列的名次都已知）
    var unknownAnchor = cand.some(function (x) { return x.a && !isFinite(x.r); });
    var allKnown = cand.every(function (x) { return isFinite(x.r); });
    var fin = !!o.exhausted || allKnown || (
      picks.length === n &&
      picks.every(function (x) { return x.rule === 'new' || x.rank !== null; }) &&
      (nAnchor >= anchorN || !unknownAnchor)
    );
    return { picks: picks, candidates: cand.length, final: fin, fresh: nFresh, relax: relax, short: Math.max(0, n - picks.length) };
  }


  function copyObj(o) { var r = Object.create(null); Object.keys(o || {}).forEach(function (k) { r[k] = 1; }); return r; }

  /**
   * V13 r3（#8、#9）：決定「每一列這一刻實際顯示什麼」。純函式，沒有 DOM、沒有網路。
   * 列的狀態：swap＝現在換上計畫；deferred＝在視窗內先不換，保留伺服器列，離開視窗才換；server＝取不到卡、退回伺服器列（不會再換）。
   * 去重以「實際顯示」為準：deferred／server 的列還顯示著伺服器那幾件，其他列不可選它們；deferred 列之後會換上自己的計畫，所以它的計畫也算已佔用。
   * 退回（server）的列計畫不會實現，不佔用。某列退回會改變其他列的計畫，所以迭代到穩定（狀態只會往「更保守」走，最多 2 倍列數次）。
   * @param {Array} cfgs  每列的 {pool, n, anchorN, newN, newDays, perVendor, perType}
   * @param {Object} rank handle -> 名次
   * @param {Object} o    {now, exhausted, base:{handle:1}（列以外頁面已出現的）, server:[[handle]]（每列現在顯示的）, inView:[bool],
   *                       avail:null|[{handle:1}]（每列拿得到卡的 handle；null＝樂觀，假設都拿得到）}
   * @returns {{plans:Array, status:Array, shown:Array, allFinal:boolean}}
   */
  function planRows(cfgs, rank, o) {
    var n = cfgs.length;
    var hold = [];
    var i;
    var j;
    for (i = 0; i < n; i += 1) { hold.push(o.inView && o.inView[i] ? 'deferred' : ''); }
    var plans;
    var allFinal;
    for (var guard = 0; guard <= 2 * n + 2; guard += 1) {
      plans = []; allFinal = true;
      var picked = Object.create(null);
      for (i = 0; i < n; i += 1) {
        var blocked = copyObj(o.base);
        Object.keys(picked).forEach(function (k) { blocked[k] = 1; });
        for (j = 0; j < n; j += 1) {
          if (j !== i && hold[j]) { (o.server[j] || []).forEach(function (k) { blocked[k] = 1; }); }
        }
        var c = cfgs[i];
        var res = pickZone(c.pool, rank, {
          n: c.n, anchorN: c.anchorN, newN: c.newN, newDays: c.newDays, perVendor: c.perVendor, perType: c.perType,
          now: o.now, blocked: blocked, exhausted: o.exhausted
        });
        plans.push(res);
        if (hold[i] !== 'server') { res.picks.forEach(function (p) { picked[p.h] = 1; }); }
        if (!res.final) { allFinal = false; }
      }
      var changed = false;
      for (i = 0; i < n; i += 1) {
        if (hold[i] === 'server') { continue; }
        var bad = !plans[i].picks.length;
        if (!bad && o.avail) { bad = plans[i].picks.some(function (p) { return !HAS.call(o.avail[i], p.h); }); }
        if (bad) { hold[i] = 'server'; changed = true; }
      }
      if (!changed) { break; }
    }
    var status = hold.map(function (x) { return x === 'server' ? 'server' : (x === 'deferred' ? 'deferred' : 'swap'); });
    var shown = status.map(function (st, k) { return st === 'swap' ? plans[k].picks.map(function (p) { return p.h; }) : (o.server[k] || []).slice(); });
    return { plans: plans, status: status, shown: shown, allFinal: allFinal };
  }

  /* ---------------- 頁面膠水（node 載入時不會跑） ---------------- */

  function handleFromHref(win, href) {
    try {
      var m = new win.URL(href, win.document.baseURI).pathname.match(/\/products\/([^/]+)/);
      if (!m) { return null; }
      try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
    } catch (e2) { return null; }
  }

  // Sharing Cup 區塊（不算佔用）：商品區的 data-cs-sharing（cs-home-shelves 的杯型區）、cs-sc-acts（Sharing Cup 各幕）、.scs-sec（sharing-cup-series 頁）
  var SHARING = ['[data-cs-sharing]', '.cs-sc-acts', '.scs-sec'];
  function inSharing(a) {
    if (!a.closest) { return false; }
    return SHARING.some(function (sel) { return !!a.closest(sel); });
  }

  // 「看得見」：商品卡（最近的 li，沒有就連結本身）有任何版面框＝getClientRects().length > 0。
  // 節點還沒插進文件、或祖先 display:none→ 0 個框 → false。沒有 getClientRects 的環境（node 假 DOM）→ true
  function isShown(el) {
    if (!el) { return false; }
    if (el.isConnected === false) { return false; }
    if (typeof el.getClientRects !== 'function') { return true; }
    return el.getClientRects().length > 0;
  }

  // 頁面上別處「看得見」的商品（精選要避開）：main 裡所有看得見的商品連結，扣掉 skipRows（精選列自己）、「更多好物」、Sharing Cup 區塊。
  // V14 r3：新品區與各專區的種類分列（[data-cs-lr]）現在算已出現（全頁同一件商品只出現一次）
  function visibleHandles(win, skipRows) {
    var out = Object.create(null);
    var main = win.document.querySelector('main') || win.document.body;
    var links = main.querySelectorAll('a[href*="/products/"]');
    Array.prototype.forEach.call(links, function (a) {
      var skip = (skipRows || []).some(function (r) { return r.contains(a); }) || (a.closest && a.closest('cs-home-feed')) || inSharing(a);
      if (skip) { return; }
      var h = handleFromHref(win, a.getAttribute('href'));
      if (!h) { return; }
      if (isShown((a.closest && a.closest('li')) || a)) { out[h] = 1; }
    });
    return out;
  }
  function pageHandles(win, rows) { return visibleHandles(win, rows); }

  function withPreview(win, url) {
    var pv = new win.URL(win.location.href).searchParams.get('preview_theme_id');
    if (pv !== null) { url.searchParams.set('preview_theme_id', pv); }
    return url;
  }

  async function fetchHtml(win, url) {
    var res = await win.fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'text/html' } });
    if (!res.ok) { throw new Error('HTTP ' + res.status); }
    return new win.DOMParser().parseFromString(await res.text(), 'text/html');
  }

  async function fetchRankPage(win, row, page) {
    var url = new win.URL(row.getAttribute('data-cs-rank-url'), win.document.baseURI);
    url.searchParams.set('section_id', 'cs-g5b-pick-rank');
    url.searchParams.set('view', 'proto-g5b');
    url.searchParams.set('sort_by', 'best-selling');
    url.searchParams.set('page', String(page));
    var doc = await fetchHtml(win, withPreview(win, url));
    var head = doc.querySelector('[data-cs-rank-page]');
    if (!head) { throw new Error('rank section missing'); }
    var per = parseInt(head.getAttribute('data-cs-rank-per'), 10) || 50;
    var pages = parseInt(head.getAttribute('data-cs-rank-pages'), 10) || 1;
    var items = Array.prototype.map.call(doc.querySelectorAll('[data-cs-rank-h]'), function (el, idx) {
      return { h: el.getAttribute('data-cs-rank-h'), pos: (page - 1) * per + idx + 1 };
    });
    return { pages: pages, items: items };
  }

  // V16 r29：精選每區拉到 8 件後，三區缺的卡可能超過 20 件；cs-g5b-pick-cards 一次只解析 20 個 handle（all_products 上限），所以每 20 件分一次請求
  async function fetchCards(win, row, handles) {
    var map = {};
    for (var i = 0; i < handles.length; i += 20) {
      var url = new win.URL(row.getAttribute('data-cs-cards-url'), win.document.baseURI);
      url.searchParams.set('q', handles.slice(i, i + 20).join(','));
      url.searchParams.set('section_id', 'cs-g5b-pick-cards');
      url.searchParams.set('view', 'proto-g5b');
      var doc = await fetchHtml(win, withPreview(win, url));
      Array.prototype.forEach.call(doc.querySelectorAll('li[data-cs-pick-h]'), function (li) {
        map[li.getAttribute('data-cs-pick-h')] = li;
      });
    }
    return map;
  }

  // data-cs-miss 可以有多個記號（空白分隔）：先去掉同名的再加，condition 為 false 就只去掉
  function addMiss(row, tok, on) {
    var cur = (row.getAttribute('data-cs-miss') || '').split(/\s+/).filter(function (x) { return x && x !== tok; });
    if (on) { cur.push(tok); }
    if (cur.length) { row.setAttribute('data-cs-miss', cur.join(' ')); } else { row.removeAttribute('data-cs-miss'); }
  }

  function mark(rows, state, miss) {
    rows.forEach(function (r) {
      r.setAttribute('data-cs-pick-state', state);
      if (miss) { addMiss(r, miss, true); }
    });
  }

  function rowServer(row) {
    var ul = row.querySelector('ul.product-grid');
    return ul ? Array.prototype.map.call(ul.querySelectorAll('li[data-cs-handle]'), function (li) { return li.getAttribute('data-cs-handle'); }) : [];
  }

  function rowInView(win, row) {
    var r = row.getBoundingClientRect();
    return r.bottom > 0 && r.top < win.innerHeight;
  }

  function feedGridOf(win) { return win.document.querySelector('cs-home-feed [data-feed-grid]'); }

  function handleOfLi(win, li) {
    var a = li.querySelector && li.querySelector('a[href*="/products/"]');
    return (a && handleFromHref(win, a.getAttribute('href'))) || (li.getAttribute && li.getAttribute('data-cs-handle')) || null;
  }

  function addToAttr(el, name, h) {
    var cur = (el.getAttribute(name) || '').split('|').filter(Boolean);
    if (cur.indexOf(h) < 0) { cur.push(h); }
    el.setAttribute(name, cur.join('|'));
  }

  // V14 r3（#1、#3）：精選與「更多好物」的同步器。精選優先；「更多好物」不可留著看得見於別處的卡，被精選換下又沒出現在別處的卡要接回「更多好物」開頭。
  // 以前只在換卡當下同步一次，而且 feed grid 還不存在就丟掉。現在：
  //   - 換下的卡一律先 queue（待接回清單，記住是哪一列換下的）
  //   - reconcile 依「現在看得見」決定：feed 裡看得見於別處的卡拿掉（收進待接回清單，之後可能再接回）、待接回清單裡「不在別處看得見、feed 也沒有」的卡接回開頭
  //   - 觸發：queue 之後立刻一次；feed grid 的子節點變動（MutationObserver：feed 首批載入、換清單、看更多）；跨 750 的 matchMedia change
  //   - 取消：feed 元素 finished 之後（feed 不會再變）取消 MutationObserver；matchMedia 監聽一個、跟頁面同壽命
  function makeFeedSync(win) {
    var S = { pending: [], rows: [], queued: 0, grid: null, mo: null, mql: null, busy: false, hasGrid: false };

    function observe(grid) {
      if (S.mo) { S.mo.disconnect(); S.mo = null; }
      S.grid = grid;
      if (!win.MutationObserver) { return; }
      S.mo = new win.MutationObserver(function () { S.reconcile(); });
      S.mo.observe(grid, { childList: true });
    }

    S.queue = function (oldLis, newHandles, row) {
      var kept = Object.create(null);
      newHandles.forEach(function (h) { kept[h] = 1; });
      var qh = [];
      if (S.rows.indexOf(row) < 0) { S.rows.push(row); }
      oldLis.forEach(function (li) {
        var h = li.getAttribute('data-cs-handle') || handleOfLi(win, li);
        if (!h || HAS.call(kept, h)) { return; }
        var had = S.pending.filter(function (e) { return e.h === h; })[0];
        if (had) { if (!had.row) { had.row = row; } return; }
        li.className = 'flex-grid__item';
        li.removeAttribute('id');
        ['data-cs-pick-rule', 'data-cs-rank', 'data-cs-rank-src', 'data-cs-pick-h'].forEach(function (k) { li.removeAttribute(k); });
        S.pending.push({ h: h, li: li, row: row });
        S.queued += 1;
        qh.push(h);
      });
      return qh;
    };

    // 回傳這一次接回的 handle 清單
    S.reconcile = function () {
      var grid = feedGridOf(win);
      S.hasGrid = !!grid;
      if (!grid || S.busy) { return []; }
      if (grid !== S.grid) { observe(grid); }
      S.busy = true;
      var vis = visibleHandles(win, []);
      var inFeed = Object.create(null);
      var removed = [];
      Array.prototype.slice.call(grid.children).forEach(function (li) {
        var h = handleOfLi(win, li);
        if (!h) { return; }
        if (HAS.call(vis, h) || HAS.call(inFeed, h)) {
          grid.removeChild(li);
          removed.push(h);
          if (HAS.call(vis, h) && !S.pending.some(function (e) { return e.h === h; })) { S.pending.push({ h: h, li: li, row: null }); }
          return;
        }
        inFeed[h] = 1;
      });
      // 清單裡的每一件（不退場）：feed 沒有、而且別處看不見 → 放回開頭。feed 被整批換掉之後會再放回來
      var add = [];
      S.pending.forEach(function (e) {
        if (HAS.call(inFeed, e.h) || HAS.call(vis, e.h)) { return; }
        add.push(e); inFeed[e.h] = 1;
      });
      if (add.length) {
        var first = grid.firstChild;
        add.forEach(function (e) { grid.insertBefore(e.li, first); if (e.row) { addToAttr(e.row, 'data-cs-rescued', e.h); } });
      }
      var feed = grid.closest ? grid.closest('cs-home-feed') : null;
      var waiting = S.pending.filter(function (e) { return !HAS.call(inFeed, e.h); }).map(function (e) { return e.h; });
      if (feed) { feed.setAttribute('data-cs-feed-sync', 'queued=' + S.queued + ';placed=' + add.map(function (e) { return e.h; }).join('|') + ';removed=' + removed.join('|') + ';waiting=' + waiting.join('|')); }
      S.rows.forEach(function (r) {
        var w = S.pending.filter(function (e) { return e.row === r && !HAS.call(inFeed, e.h); }).map(function (e) { return e.h; });
        if (w.length) { r.setAttribute('data-cs-rescue-wait', w.join('|')); } else { r.removeAttribute('data-cs-rescue-wait'); }
      });
      if (S.mo) { S.mo.takeRecords(); }
      if (feed && feed.finished === true && S.mo) { S.mo.disconnect(); S.mo = null; }
      S.busy = false;
      return add.map(function (e) { return e.h; });
    };

    // 跨 750 時看得見的集合會變：重新同步一次（精選列本身不重排，限制見檔頭）
    if (win.matchMedia) {
      try {
        S.mql = win.matchMedia('(min-width: 750px)');
        var onChange = function () { S.reconcile(); };
        if (S.mql.addEventListener) { S.mql.addEventListener('change', onChange); } else if (S.mql.addListener) { S.mql.addListener(onChange); }
      } catch (e) { S.mql = null; }
    }
    return S;
  }

  /*
    V14 r6（B2）：「更多好物」狀態文字的件數對齊畫面。cs-home-feed.js 寫的是「這一批」的張數，picks.js 又接回、去重過卡，所以文字與實際張數不符。
    只換文字裡的數字（不新增、不改寫字）：「已載入 N 件商品。」「已載入 N 件商品，已全部顯示。」→ N 換成 [data-feed-grid] > li 的實際張數。
    其他已知句子（空字串、載入中…、已全部顯示。、載入失敗…）不動；認不得的句子不動，並在 feed 上印記號。
    記號 data-cs-status-fix（feed 元素）：fixed:舊->新 ／ ok:N ／ skip:代號 ／ unknown:len=字數。認不得時另加 data-cs-miss="status-unknown"。
    自觸發：只在文字真的不同才寫；寫完 takeRecords。監看狀態文字與 grid 子節點，沒有 feed 回 'nofeed'。
  */
  /*
    r53：狀態文字改成四語（sections/cs-home-feed.liquid 依 request.locale.iso_code 寫在 <cs-home-feed> 的 data-msg-*，{n}＝件數，{more}＝看更多按鈕的字）。
    這裡不再寫死繁中句子，改用同一組 data-msg-* 組出比對式；讀不到就用繁中（r53 之前的字），watchFeedStatus 在 feed 上印 data-cs-status-msg＝attr／fallback:缺的鍵。
    第 4 個參數 M 不給時用繁中，舊的三參數呼叫照舊。
  */
  var STATUS_MSG_FALLBACK = {
    loaded: '已載入 {n} 件商品。',
    loadedAll: '已載入 {n} 件商品，已全部顯示。',
    allShown: '已全部顯示。',
    loading: '載入中…',
    failed: '載入失敗，請按「{more}」重試。'
  };
  function feedStatusMessages(feed) {
    var ds = (feed && feed.dataset) || {}, M = {}, miss = [];
    Object.keys(STATUS_MSG_FALLBACK).forEach(function (k) {
      var v = ds['msg' + k.charAt(0).toUpperCase() + k.slice(1)];
      if (v) { M[k] = v; } else { M[k] = STATUS_MSG_FALLBACK[k]; miss.push(k); }
    });
    M.src = miss.length ? 'fallback:' + miss.join(',') : 'attr';
    return M;
  }
  // 句型 → 整句比對式：{n} 換成 (\d+)、{more} 換成 .*，其餘字元照字面
  function statusPattern(t) {
    var esc = String(t).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('^' + esc.split('\\{n\\}').join('(\\d+)').split('\\{more\\}').join('.*') + '$');
  }
  function statusFixText(text, n, tailHidden, M) {
    M = M || STATUS_MSG_FALLBACK;
    var fill = function (t) { return t.split('{n}').join(String(n)); };
    var mL = statusPattern(M.loaded).exec(text);
    var mA = mL ? null : statusPattern(M.loadedAll).exec(text);
    var m = mL || mA;
    // V16 r17：尾巴被藏時不可說「已全部顯示」，只用「已載入 N 件商品。」那一句（r53 起為當頁語言的同一句）
    if (tailHidden && (m ? !!mA : text === M.allShown)) { return { text: fill(M.loaded), kind: 'tail-nofin:' + n }; }
    if (m) { return { text: fill(mA ? M.loadedAll : M.loaded), kind: String(n) === m[1] ? 'ok:' + n : 'fixed:' + m[1] + '->' + n }; }
    if (text === '') { return { text: text, kind: 'skip:empty' }; }
    if (text === M.loading) { return { text: text, kind: 'skip:loading' }; }
    if (text === M.allShown) { return { text: text, kind: 'skip:all-shown' }; }
    if (statusPattern(M.failed).test(text)) { return { text: text, kind: 'skip:failed' }; }
    return { text: text, kind: 'unknown:len=' + text.length };
  }

  function watchFeedStatus(win) {
    var feed = win.document.querySelector('cs-home-feed');
    var status = feed && feed.querySelector('[data-feed-status]');
    var grid = feed && feed.querySelector('[data-feed-grid]');
    if (!feed || !status || !grid) { return 'nofeed'; }
    var M = feedStatusMessages(feed);
    feed.setAttribute('data-cs-status-msg', M.src);
    var mos = [];
    function isLi(c) { return !!(c.tagName && String(c.tagName).toLowerCase() === 'li'); }
    function count() {
      var n = 0;
      Array.prototype.forEach.call(grid.children, function (c) { if (isLi(c) && !c.hasAttribute('data-cs-tail')) { n += 1; } });
      return n;
    }
    /*
      V16 r16（A1）：最後一列不孤零零。feed 的 cs-home-feed.js 每批一定交 12 張（takeCards 以 count 為上限），英日簡的第一批卻是 13：
      多出來的 1 張是上面 makeFeedSync.reconcile 把「精選換下、別處又看不見」的卡接回 grid 開頭。13＋12＋12… 對 2／3／4 欄都餘 1，最後一列只剩 1 張。
      接回的張數隨語言與精選結果而變（繁中 0、英日簡 1），所以不改張數、改成「不滿的最後一列不顯示」：
      欄數＝第一張看得見的卡那一橫列有幾張（量位置，不寫死 2／3／4）；尾數＝張數 mod 欄數；尾數那幾張寫 data-cs-tail（CSS 在 cs-g5b-v13.liquid 設 display:none）。
      張數不足一列（< 欄數）不處理。每次先把舊記號清掉再量，所以續載一批、跨斷點、視窗縮放都會重算；被藏的卡不刪，續載補滿那一列時自然現身。
      記號 data-cs-tail-fix（feed 元素）：cols=欄數;n=li 張數;hid=藏幾張。
    */
    function trimTail() {
      var lis = Array.prototype.filter.call(grid.children, isLi);
      lis.forEach(function (c) { c.removeAttribute('data-cs-tail'); });
      var shown = lis.filter(function (c) { return c.getClientRects().length > 0; });
      var cols = 0;
      if (shown.length) {
        var top0 = shown[0].offsetTop;
        shown.forEach(function (c) { if (Math.abs(c.offsetTop - top0) < 2) { cols += 1; } });
      }
      // V16 r16 補：商品真的沒了（見下）就全部顯示，不藏；finished 見 cs-home-feed.js 第 28、523 行
      // 耗盡＝finished 且 sourceHasMore() 為 false（cs-home-feed.js 第 427–429 行：buffer 空且 source.exhausted）；到頁數上限（reachedLimit）不算耗盡。讀不到 sourceHasMore 當未耗盡（照藏），記號印 fin=x
      var shm = typeof feed.sourceHasMore === 'function';
      var fin = feed.finished === true && shm && !feed.sourceHasMore();
      // V16 r17：續載失敗時尾卡一律顯示（寧可孤列、不可有商品看不到）。信號＝cs-home-feed.js fail() 的 announce(msg('failed'))（r53 起四語，比對式由 data-msg-failed 組出，見 statusPattern）：
      // feed 沒有失敗旗標，只留這句狀態文字（每次載入開始 setLoading 會換成「載入中…」，所以重試後信號自然消失）。讀不到狀態文字（不是字串）→ err=x、照藏
      var stxt = status.textContent;
      var errKnown = typeof stxt === 'string';
      var err = errKnown && statusPattern(M.failed).test(stxt);
      var hid = (!fin && !err && cols > 1 && shown.length > cols) ? shown.length % cols : 0;
      for (var i = 0; i < hid; i += 1) { shown[shown.length - 1 - i].setAttribute('data-cs-tail', '1'); }
      feed.setAttribute('data-cs-tail-fix', 'cols=' + cols + ';n=' + shown.length + ';hid=' + hid + ';fin=' + (shm ? (fin ? 1 : 0) : 'x') + ';err=' + (errKnown ? (err ? 1 : 0) : 'x'));
      return hid > 0;
    }
    function fix() {
      var tailHidden = trimTail();
      var r = statusFixText(status.textContent || '', count(), tailHidden, M);
      if (r.text !== status.textContent) { status.textContent = r.text; }
      feed.setAttribute('data-cs-status-fix', r.kind);
      addMiss(feed, 'status-unknown', r.kind.indexOf('unknown:') === 0);
      mos.forEach(function (mo) { if (mo.takeRecords) { mo.takeRecords(); } });
    }
    if (win.MutationObserver) {
      var a = new win.MutationObserver(fix); a.observe(status, { childList: true, characterData: true, subtree: true }); mos.push(a);
      var b = new win.MutationObserver(fix); b.observe(grid, { childList: true }); mos.push(b);
    }
    if (win.addEventListener) {
      var pend = false;
      win.addEventListener('resize', function () {
        if (pend) { return; }
        pend = true;
        (win.requestAnimationFrame || function (f) { return win.setTimeout(f, 50); })(function () { pend = false; fix(); });
      });
    }
    fix();
    return 'watching';
  }

  async function run(win, rows) {
    var cfgs = rows.map(function (row) {
      var el = row.querySelector('script[data-cs-pick-pool]');
      return JSON.parse(el.textContent);
    });
    var maxPages = parseInt(rows[0].getAttribute('data-cs-rank-max'), 10) || 8;
    var rank = Object.create(null);
    var sync = makeFeedSync(win);
    var page = 0;
    var pages = Infinity;
    var exhausted = false;
    var plan;
    var capped = false;

    function planNow(avail) {
      var base = pageHandles(win, rows);
      var res = planRows(cfgs, rank, {
        now: Math.floor(Date.now() / 1000), exhausted: exhausted, base: base,
        server: rows.map(rowServer), inView: rows.map(function (r) { return rowInView(win, r); }), avail: avail
      });
      res.blockedBase = base;
      return res;
    }

    for (;;) {
      plan = planNow(null);
      if (plan.allFinal) { break; }
      if (page >= pages) { exhausted = true; continue; }
      if (page >= maxPages) { exhausted = true; capped = true; continue; }
      page += 1;
      var got = await fetchRankPage(win, rows[0], page);
      pages = got.pages;
      got.items.forEach(function (x) { rank[x.h] = x.pos; });
      if (page >= pages) { exhausted = true; }
    }

    // 需要的卡：原本列裡有的直接拿，沒有的一次向 /search 取（只算還沒退回的列）
    function own(row, h) { return row.querySelector('li[data-cs-handle="' + h.replace(/"/g, '\\"') + '"]'); }
    var need = [];
    plan.plans.forEach(function (res, ri) {
      if (plan.status[ri] === 'server') { return; }
      res.picks.forEach(function (p) { if (!own(rows[ri], p.h) && need.indexOf(p.h) < 0) { need.push(p.h); } });
    });
    var fetched = {};
    if (need.length) { fetched = await fetchCards(win, rows[0], need); }

    // 之後到「確定要動 DOM」之間沒有 await：視窗位置、各列拿得到的卡都在同一刻讀，決定與動作一致（#8）
    var avail = rows.map(function (row) {
      var a = {};
      rowServer(row).forEach(function (h) { a[h] = 1; });
      Object.keys(fetched).forEach(function (h) { a[h] = 1; });
      return a;
    });
    plan = planNow(avail);
    rows.forEach(function (row, ri) {
      var res = plan.plans[ri];
      if (plan.status[ri] === 'server') { mark([row], 'server', 'pick-cards'); return; }
      var ul = row.querySelector('ul.product-grid');
      var lis = [];
      var missing = false;
      res.picks.forEach(function (p) {
        var li = own(row, p.h) || fetched[p.h];
        if (!li) { missing = true; return; }
        li = li.parentNode === ul ? li : win.document.importNode(li, true);
        li.setAttribute('data-cs-handle', p.h);
        li.setAttribute('data-cs-pick-rule', p.rule);
        li.setAttribute('data-cs-rank', p.rank === null ? '-' : String(p.rank));
        li.setAttribute('data-cs-rank-src', 'best-selling');
        li.removeAttribute('data-cs-pick-h');
        li.className = 'flex-grid__item slider__slide';
        lis.push(li);
      });
      if (missing || !lis.length) { mark([row], 'server', 'pick-cards'); return; }
      row.setAttribute('data-cs-candidates', String(res.candidates));
      row.setAttribute('data-cs-shown', String(lis.length));
      row.setAttribute('data-cs-pick-rules', res.picks.map(function (p) { return p.rule; }).join(','));
      var newH = res.picks.map(function (p) { return p.h; });
      swapWhenSafe(win, row, ul, lis, plan.status[ri] === 'swap', function (oldLis) {
        row.setAttribute('data-cs-relax', res.relax || '');
        addMiss(row, 'pick-short', res.short > 0);
        row.setAttribute('data-cs-rescued', '');
        var queued = sync.queue(oldLis, newH, row);
        sync.reconcile();
        row.setAttribute('data-cs-vis', typeof row.getClientRects === 'function' ? 'getClientRects' : 'none');
        row.setAttribute('data-cs-blocked-n', String(Object.keys(plan.blockedBase || {}).length));
        addMiss(row, 'rescue-nofeed', queued.length > 0 && !sync.hasGrid);
      });
    });
    if (capped) { mark(rows, rows[0].getAttribute('data-cs-pick-state') || 'sorted', 'rank-cap'); }
  }

  // 規劃時已決定這一列現在換（swap）或先不換（deferred：在視窗內，離開視窗才換；一直在視窗內就維持伺服器端那一列）。換成功才登記「更多好物」去重與接回（done，帶換下來的舊 li）
  function swapWhenSafe(win, row, ul, lis, now, done) {
    function doSwap() {
      var oldLis = Array.prototype.slice.call(ul.children);
      ul.replaceChildren.apply(ul, lis);
      row.setAttribute('data-cs-pick-state', 'sorted');
      done(oldLis);
    }
    if (now) { doSwap(); return; }
    row.setAttribute('data-cs-pick-state', 'deferred');
    if (!('IntersectionObserver' in win)) { return; }
    var io = new win.IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return !e.isIntersecting; })) { io.disconnect(); doSwap(); }
    });
    io.observe(row);
  }

  function boot(win) {
    var doc = win.document;
    if (win.__csG5bPicksBooted) { return; } // V14 r3（Codex #2）：同頁載入兩次也只啟動一次
    win.__csG5bPicksBooted = true;
    function go() {
      var rows = Array.prototype.slice.call(doc.querySelectorAll('[data-cs-pick-auto]'));
      if (!rows.length || !win.fetch || !win.DOMParser) { return; }
      mark(rows, 'server', '');
      addMiss(rows[0], 'status-nofeed', watchFeedStatus(win) === 'nofeed');
      run(win, rows).catch(function () { mark(rows, 'server', 'pick-sort'); });
    }
    if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', go); } else { go(); }
  }

  /*
    V14 r4：slide-stop 的 detail 不是整數（NaN）時，主題原有的 modules-basis.js updateSlideState 會讀 children[NaN].classList 而丟 TypeError。
    讀碼事實：assets/scrollsnap.js 的 dispatch 用 new CustomEvent('slide-stop', {detail}) 在 slider 元素（ul is="scroll-snap-slider"）自己身上發，
    沒有 bubbles（預設 false）；主題的 listener 也掛在那條 ul 自己身上（modules-basis.js 約 53 行）。
    非 bubbles 事件仍會走 capture 階段（window → document → … → ul 的祖先 → target），所以掛在 document 的 capture listener 一定比 ul 上的 listener 先收到。
    先印再擋：detail 不是整數 → 在 target 上寫 data-cs-snap-nan（次數）、push 一筆到 window.__csSnapNan（最多 50 筆）；
    再 stopImmediatePropagation()：事件在 capture 階段被停掉就不會進 target 階段，ul 上的 listener 不會被呼叫。
    整數 detail 完全不干預。本檔只在 g5b 載入（sections/cs-home-shelves.liquid 的 cs_x3_on 才輸出 script 標籤）。
    itemSize 是 ScrollSnapSlider 實例的屬性，不在元素上；元素上讀不到（沒有指向實例的屬性）就記 null。
  */
  function guardSlideStop(win) {
    try {
      var doc = win && win.document;
      if (!doc || typeof doc.addEventListener !== 'function') { return; }
      if (win.__csSnapGuardOn) { return; }
      win.__csSnapGuardOn = true;
      if (!win.__csSnapNan) { win.__csSnapNan = []; }
      doc.addEventListener('slide-stop', function (event) {
        if (Number.isInteger(event.detail)) { return; }
        var el = event.target;
        try {
          var n = parseInt(el.getAttribute('data-cs-snap-nan'), 10);
          el.setAttribute('data-cs-snap-nan', String((isNaN(n) ? 0 : n) + 1));
          var size = null;
          try {
            var inst = el.slider || el.scrollSnapSlider || el._slider || null;
            if (inst && typeof inst.itemSize !== 'undefined') { size = inst.itemSize; }
          } catch (e1) { size = null; }
          var list = win.__csSnapNan;
          list.push({
            t: Date.now(),
            id: el.id || '',
            className: String(el.className || ''),
            detail: String(event.detail),
            itemSize: size,
            scrollLeft: el.scrollLeft,
            children: el.children ? el.children.length : null,
            offsetWidth: el.offsetWidth
          });
          if (list.length > 50) { list.splice(0, list.length - 50); }
        } catch (e2) { /* 記號寫失敗也要擋 */ }
        event.stopImmediatePropagation();
      }, true);
    } catch (e) { /* 不可影響頁面其他功能 */ }
  }

  /*
    V15 r9：414 新品列（ul id 結尾 row-new-products）是兩列網格，第一張大卡 sticky，第 1、2 個 li 的 offsetLeft 都是 0；
    assets/scrollsnap.js 第 176 行預設 sizingMethod（第二個減第一個）得 0，slide＝round(scrollLeft／0)＝Infinity／NaN。
    只對這條 ul 換掉實例的 sizingMethod（不是只改一次 itemSize：ResizeObserver 的 rafSlideSize 每次都會再呼叫 this.sizingMethod）。
    實例由 assets/modules-basis.js 第 27 行 this.slider = sliderSimple 設在 ul 上，且要第一次可見後才建立；
    所以在 ul 上先放一個 slider 的 setter，實例一指派就換量法（同一個同步段落內，建構子排的第一次 rAF 還沒跑，用的就是新量法）；已有實例則直接換並重算一次。
    量法：第二減第一是正數就照舊；相同就用第三減第二；仍不是正數就退回第一個的 offsetWidth；
    都不行就維持原 itemSize 並在 ul 上印 data-cs-miss="snap-size"、data-cs-snap-size="第二減第一,第三減第二,第一個寬"。
  */
  function snapSizeOf(slider) {
    var el = slider.element, k = el && el.children, a = k && k[0], b = k && k[1], c = k && k[2];
    if (!a) { return slider.itemSize; }
    var d1 = b ? b.offsetLeft - a.offsetLeft : null;
    var d2 = (b && c) ? c.offsetLeft - b.offsetLeft : null;
    var w = a.offsetWidth;
    var out = null;
    if (b && d1 > 0) { out = d1; }
    else if (d2 > 0) { out = d2; }
    else if (w > 0) { out = w; }
    try {
      if (out === null) {
        addMiss(el, 'snap-size', true);
        el.setAttribute('data-cs-snap-size', [d1, d2, w].join(','));
      } else {
        addMiss(el, 'snap-size', false);
        el.removeAttribute('data-cs-snap-size');
      }
    } catch (e) { /* 記號寫失敗不影響量測 */ }
    return out === null ? slider.itemSize : out;
  }

  function patchSlider(inst, fresh) {
    if (!inst || typeof inst !== 'object') { return; }
    inst.sizingMethod = function (s) { return snapSizeOf(s); };
    if (!fresh && typeof inst.rafSlideSize === 'function') { inst.rafSlideSize(); }
  }

  function patchSnapSize(win) {
    try {
      var doc = win && win.document;
      if (!doc || typeof doc.querySelectorAll !== 'function') { return; }
      var run = function () {
        var uls = doc.querySelectorAll('ul[id$="row-new-products"]');
        Array.prototype.forEach.call(uls, function (ul) {
          if (ul.__csSnapSizeOn) { return; }
          ul.__csSnapSizeOn = true;
          var cur = ul.slider;
          if (cur) { patchSlider(cur, false); }
          try {
            Object.defineProperty(ul, 'slider', {
              configurable: true, enumerable: true,
              get: function () { return cur; },
              set: function (v) { cur = v; patchSlider(v, true); }
            });
          } catch (e) { /* 定義失敗就維持主題原量法 */ }
        });
      };
      if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', run); } else { run(); }
    } catch (e) { /* 不可影響頁面其他功能 */ }
  }

  return { snapSizeOf: snapSizeOf, patchSnapSize: patchSnapSize, pickZone: pickZone, planRows: planRows, boot: boot, guardSlideStop: guardSlideStop,statusFixText: statusFixText, watchFeedStatus: watchFeedStatus };
});
